<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-column w-100">
                        <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-3"
                             :key="objectKey + '-header'">
                            <span class="h3 mb-2 mb-lg-0" v-if="!object.id">
                                <span>Заявка</span>
                                <span v-if="isRelease()"> на выпуск</span>
                                <span v-else-if="isMonitoring()"> на мониторинг</span>
                            </span>
                            <span class="h3 mb-2 mb-lg-0 mr-3" v-else>{{ header }}</span>
                            <sup><small v-if="!object.id" class="text-secondary ml-2">Новая</small></sup>
                            <request-status-indicator :request="object" />
                        </div>
                        <div v-if="object.isArchived" class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-3">
                            <span class="text-secondary border rounded" style="padding: 5px 12px">В архиве c {{ object.archiveDate }}</span>
                        </div>

                        <div v-if="object.isFromNavigator" class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-3">
                            <span class="text-info border rounded" style="padding: 5px 12px">С сайта</span>
                        </div>
                    </div>

                </div>

                <div class="d-flex flex-grow-0 flex-wrap justify-content-start justify-content-xl-end mr-n2 w-100" v-if="object.id && getAbility()">
                    <div v-if="object.status === requestStatuses.ASSIGNED && canWork" class="mr-2 mb-2">
                        <b-button variant="primary" size="sm" @click="updateStatus(requestStatuses.WIP)" class="mr-2"><b-icon icon="arrow-right"/> Взять в работу</b-button>
                    </div>
                    <div v-if="object.status === requestStatuses.DONE && canWork" class="mr-2 mb-2">
                        <b-button variant="primary" size="sm" @click="updateStatus(requestStatuses.WIP)" class="mr-2"><b-icon icon="arrow-right"/> Взять в работу</b-button>
                    </div>
                    <div v-if="object.status === requestStatuses.ASSIGNED && canControl" class="mr-2 mb-2">
                        <b-button variant="secondary" size="sm" @click="updateStatus(requestStatuses.OPEN)">Снять назначение</b-button>
                    </div>
                    <div v-if="object.status === requestStatuses.WIP && canMarkAsDone" class="mr-2 mb-2">
                        <b-button variant="success" size="sm" @click="updateStatus(requestStatuses.DONE)" class="mr-2"><b-icon icon="check2" /> Отметить выполнение</b-button>
                    </div>
                    <div v-if="(object.status === requestStatuses.OPEN || object.status === requestStatuses.ASSIGNED) && canControl" class="mr-2 mb-2">
                        <b-button variant="danger" size="sm" @click="updateStatus(requestStatuses.CANCELLED)"><b-icon icon="x"/> Отменить</b-button>
                    </div>
<!--                    <div v-if="object.status === requestStatuses.DONE && canControl" class="mr-2 mb-2">-->
<!--                        <b-button variant="secondary" size="sm" @click="updateStatus(requestStatuses.CLOSED)">Закрыть</b-button>-->
<!--                    </div>-->
                    <div v-if="object.status === requestStatuses.CANCELLED && canControl" class="mr-2 mb-2">
                        <b-button variant="primary" size="sm" @click="updateStatus(requestStatuses.OPEN)">Открыть заново</b-button>
                    </div>
                    <div v-if="isCatching() && canAddEvents" class="mr-2">
                        <b-button variant="info" size="sm" @click="onCatchingEventCreate"><b-icon icon="plus" /> Добавить пойманных животных</b-button>
                    </div>
                    <div v-if="isMonitoring() && canAddEvents" class="mr-2">
                        <b-button variant="info" size="sm" @click="onMonitoringEventCreate"><b-icon icon="plus" /> Добавить пойманных животных</b-button>
                    </div>
                </div>

            </div>


            <div id="requestForm">

                    <b-form-row class="mb-3">
                        <form-field v-if="!object.id && !this.initialActivity"
                                :label="getFieldLabel('activity')"
                                class="col-xs-5 col-sm-4 col-lg-3 required m-2"
                                :editable="getAbility('activity')"
                                :value="object.activityName"
                                :feedback="liveFeedback('activity')">
                            <template #field>
                                <single-select name="activity"
                                   class="flex-grow-1"
                                   v-model="form['activityObject']"
                                   :url="getActivitiesUrl"
                                   :label="getFieldLabel('activity')"
                                   :state="getValidationClass('activity')"
                                   :initial-filters="activitiesInitialFilters"
                                   :has-search="false"
                                   v-on:select-changed="onActivityChanged"
                                   v-on:select-cleared="onModelObjectSingleSelectCleared" />
                            </template>
                        </form-field>
                    </b-form-row>

                    <b-form-row>
                        <b-col sm="12" class="m-2">
                            <map-municipality-list :selected-municipality="selectedMunicipality"
                                                   :editable="getAbility('address') && canEditRequest()"
                                                   @on-municipality-click="onMunicipalityClick"/>
                        </b-col>
                    </b-form-row>

                    <b-form-row class="mb-3">
                        <form-field class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                    :key="objectKey"
                                    :editable="getAbility('contract') && canUpdateContract() && Boolean(form.activity) && Boolean(selectedMunicipality)"
                                    :label="getFieldLabel('contract')"
                                    :value="object.contractObject ? object.contractObject['full_description'] : null"
                                    :feedback="liveFeedback('contract')">
                            <template #field>
                                <single-select name="contract"
                                       class="flex-grow-1"
                                       v-model="form['contractObject']"
                                       :url="getContractsUrl"
                                       :label="getFieldLabel('contract')"
                                       label-key="full_description"
                                       :state="getValidationClass('contract')"
                                       :initial-filters="contractInitialFilters"
                                       v-on:select-changed="onModelObjectSingleSelectChanged"
                                       v-on:select-cleared="onModelObjectSingleSelectCleared" />
                            </template>
                        </form-field>
                    </b-form-row>

                    <b-form-row  class="mb-3">
                        <form-field
                            :label="getFieldLabel('address')"
                            class="col-xs-12 col-lg-10 col-xl-6 m-2 required"
                            :editable="getAbility('address') && canEditRequest()"
                            :feedback="liveFeedback('address')"
                            :value="form.addressHumanReadable ? form.addressHumanReadable : 'Не указан'">

                            <template #value>
                                <map-box ref="map" :coordinates="selectedCoordinates" style="width: 100%; height: 500px"/>
                                <div class="clearfix p-1"></div>
                                <div class="col-12 p-0 m-0 d-flex align-items-center">
                                    <div class="flex-grow-1 mr-2">{{ form.addressHumanReadable ? form.addressHumanReadable : 'Не указан' }}</div>
                                    <b-button variant="link" class="p-0" @click="onAddressFocus">
                                        <img :src="focus" width="32"/>
                                    </b-button>
                                </div>
                            </template>

                        <template #field>
                            <div class="clearfix p-1"></div>
                            <map-box ref="map"
                                     :coordinates="selectedCoordinates"
                                     :center-lat="selectedMunicipality ? parseFloat(selectedMunicipality.lat) : 68.9614"
                                     :center-lon="selectedMunicipality ? parseFloat(selectedMunicipality.lon) : 33.0955"
                                     v-on:map-clicked="onMapClicked" style="width: 100%; height: 500px"/>
                            <div class="clearfix p-1"></div>
                            <div v-if="selectedMunicipality" class="col-12 p-0 m-0 d-flex">
                                <single-select name="address"
                                               ref="address"
                                               class="flex-grow-1 mr-2"
                                               v-model="form['addressObject']"
                                               :url="getAddressUrl"
                                               :label="getFieldLabel('address')"
                                               label-key="short_text"
                                               :state="getValidationClass('address')"
                                               :has-pagination="false"
                                               :initial-filters="addressInitialFilters"
                                               placeholder="Поиск адреса в выбранном муниципалитете"
                                               v-on:select-search-init="onAddressSearchStart"
                                               v-on:select-changed="onAddressChanged"
                                               v-on:select-set="onAddressSet"
                                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                                <b-button variant="link" class="p-0" @click="onAddressFocus">
                                    <img :src="focus" width="32"/>
                                </b-button>
                            </div>
                        </template>
                    </form-field>
                </b-form-row>

                <b-form-row>
                    <form-field v-if="isCatching()"
                                class="col-xs-5 col-sm-4 col-lg-3 m-2"
                                :editable="getAbility('animalSpecies') && canEditRequest()"
                                :label="getFieldLabel('animalSpecies')"
                                :value="object.animalSpeciesName"
                                :feedback="liveFeedback('animalSpecies')">
                        <template #field>
                            <single-select name="animalSpecies"
                                           class="flex-grow-1 mr-2"
                                           v-model="form['animalSpeciesObject']"
                                           :url="getAnimalSpeciesUrl"
                                           :label="getFieldLabel('animalSpecies')"
                                           :state="getValidationClass('animalSpecies')"
                                           :has-search="false"
                                           v-on:select-changed="onModelObjectSingleSelectChanged"
                                           v-on:select-cleared="onModelObjectSingleSelectCleared" />
                        </template>
                    </form-field>

                    <form-field v-if="isRelease() && canEditRequest() && getAbility('animalsToRelease')"
                                :label="getFieldLabel('animalsToRelease')"
                                class="col-xs-12 col-xl-8 m-2"
                                :editable="getAbility('animalsToRelease')"
                                :feedback="liveFeedback('animalsToRelease')"
                                :value="form['animalObjectsToRelease']">
                        <template #field>
                            <list-select name="animalsToRelease"
                                         v-model="form['animalObjectsToRelease']"
                                         :url="getAnimalsUrl"
                                         :label="getFieldLabel('animalsToRelease')"
                                         :state="getValidationClass('animalsToRelease')"
                                         :initial-filters="animalsToReleaseInitialFilters"
                                         label-key="full_name"
                                         can-remove-key="can_release"
                                         v-on:select-added="onModelObjectListAdded"
                                         v-on:select-removed="onModelObjectListRemoved">
                                <template v-slot:selected-item="slotProps">
                                    <animal-dropdown-item :animal="slotProps.item" class="text-secondary"/>
                                </template>
                                <template v-slot:option="slotProps">
                                    <animal-dropdown-item :animal="slotProps.item" />
                                </template>
                            </list-select>

                        </template>
                    </form-field>


                    <form-field v-if="isRelease()  && (!canEditRequest() || !getAbility('animalsToRelease'))"
                                :label="getFieldLabel('animalsToRelease')"
                                class="col-xs-12 col-xl-8 m-2"
                                :editable="true"
                                :feedback="liveFeedback('animalsToRelease')">
                        <template #field>
                            <div class="d-flex flex-wrap mt-2">
                                <div v-for="(animal, i) in form['animalObjectsToRelease']" class="mb-3 mr-3">
                                    <animal-link :animal="animal" />
                                </div>
                            </div>
                        </template>
                    </form-field>

                    <form-field  v-if="isCatching() && object.animalsCount !== null"
                                 class="col-xs-3 col-sm-2 col-lg-2 required m-2"
                                 :label="getFieldLabel('animalsCount')"
                                 :editable="getAbility('animalsCount') && canEditRequest()"
                                 :value="object.animalsCount.toString()"
                                 :feedback="liveFeedback('animalsCount')">
                        <template #field>
                            <b-form-input
                                id="animalsCount"
                                class="w-100"
                                type="text"
                                v-model="$v.form.animalsCount.$model"
                                :state="validateState('animalsCount')">
                            </b-form-input>
                        </template>
                    </form-field>

                    <form-field v-if="isCatching() && object.id"
                                class="col-xs-3 col-sm-2 col-lg-2 m-2"
                                :editable="false"
                                label="Поймано">
                        <template #value>
                            {{ object.caughtCount }}
                        </template>
                    </form-field>

                    <form-field :label="getFieldLabel('description')"
                                class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                :value="object.description"
                                :editable="getAbility('description') && canEditRequest()"
                                :feedback="liveFeedback('description')">
                            <template #field>
                                    <b-form-textarea
                                        id="description"
                                        class="w-100"
                                         v-model="$v.form.description.$model"
                                        :state="validateState('description')">
                                    </b-form-textarea>
                            </template>
                    </form-field>
                </b-form-row>


                <b-form-row>
                    <form-field v-if="isCatching()"
                                :label="getFieldLabel('applicant')"
                                class="col-xs-5 col-sm-4 col-lg-3 m-2"
                                :editable="getAbility('applicant') && canEditRequest()"
                                :value="object.applicant"
                                :feedback="liveFeedback('applicant')">
                        <template #field>
                            <b-form-input
                                id="applicant"
                                class="w-100"
                                type="text"
                                v-model="$v.form.applicant.$model"
                                :state="validateState('applicant')">
                            </b-form-input>
                        </template>
                    </form-field>

                    <form-field v-if="isCatching()"
                                :label="getFieldLabel('applicantPhone')"
                                class="col-xs-5 col-sm-4 col-lg-3 m-2"
                                :editable="getAbility('applicantPhone') && canEditRequest()"
                                :value="object.applicantPhone"
                                :feedback="liveFeedback('applicantPhone')">
                        <template #field>
                            <b-form-input
                                id="applicantPhone"
                                class="w-100"
                                type="text"
                                v-model="$v.form.applicantPhone.$model"
                                :state="validateState('applicantPhone')">
                            </b-form-input>
                        </template>
                    </form-field>

                    <form-field id="result"
                                :label="getFieldLabel('result')"
                                class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                :editable="getAbility('result') && canEditRequest()"
                                :value="object.result"
                                :feedback="liveFeedback('result')">
                            <template #field>
                                    <b-form-textarea
                                            class="w-100"
                                            id="result"
                                            v-model="$v.form.result.$model"
                                            :state="validateState('result')" >
                                    </b-form-textarea>
                            </template>
                    </form-field>

                    <form-field id="refuseReason"
                                :label="getFieldLabel('refuseReason')"
                                class="col-xs-12 col-lg-10 col-xl-6 m-2"
                                :editable="getAbility('refuseReason') && canEditRequest() && object.status === requestStatuses.ASSIGNED"
                                :value="object.refuseReason"
                                :feedback="liveFeedback('refuseReason')">
                            <template #field>
                                    <b-form-textarea
                                            class="w-100 mb-2"
                                            id="result"
                                            v-model="$v.form.refuseReason.$model"
                                            :state="validateState('refuseReason')" >
                                    </b-form-textarea>
                                    <div v-if="object.status === requestStatuses.ASSIGNED && canWork" class="mr-2 mb-2">
                                        <small class="text-secondary mr-2">Для отказа обязательно заполните причину.</small>
                                        <b-button variant="danger" size="sm" :disabled="!Boolean(form.refuseReason)"
                                                  @click="updateStatus(requestStatuses.OPEN, {'refuseReason': $v.form.refuseReason.$model})"
                                                  class="mr-2">Отказаться</b-button>
                                    </div>
                            </template>
                    </form-field>
                </b-form-row>

                <b-form-row v-if="object.id">
                    <form-field id="created_at"
                                class="col-xs-5 col-md-5 m-2"
                                :editable="false"
                                label="Создана">
                            <template #value>
                                <div class="d-flex flex-column">
                                    <div>{{ object.createdAtDate }}</div>
                                    <div class="text-secondary">{{ object.createdAtTime }}</div>
                                </div>
                            </template>
                    </form-field>
                </b-form-row>
            </div>

            <object-form-buttons
                :disabled="loading"
                :has-changes="hasChanges"
                :object-exists="Boolean(object.id)"
                @object-create="onCreate"
                @object-update="updateRequestObject"
                @object-cancel-changes="cancelRequestChanges" class="mb-5"/>

            <div v-if="object.id && (canWork || canControl)">
                <raids-list :request="object" :animal-filters="animalsToReleaseInitialFilters" @request-release-count-updated="updateReleaseAnimalsField" />
            </div>

            <div class="mt-5" v-show="animals.length > 0 && (isCatching() || isMonitoring())">
                <div class="h5 mb-4">Животные</div>
                <div class="d-flex flex-wrap">
                    <div v-for="(animal, i) in animals" :key="i" class="mr-4 mb-4">
                        <animal-link :animal="animal" />
                    </div>
                </div>
            </div>

        </b-card>

        <stub v-else :failed-loading="failedLoading"/>

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>
    </div>

</template>

<script>
    import RaidsList from "../Raids/RaidsList";
    import { Request } from "./request";
    import { mapGetters } from 'vuex';
    import FormField from "../../../components/Forms/FormField";
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import { RequestStatus } from "./request";
    import api from "../../../api";
    import httpClient from "../../../http";
    import AnimalAvatar from "../Animals/AnimalAvatar";
    import {Animal} from "../Animals/animal";
    import ObjectFormButtons from "../../../components/Forms/ObjectFormButtons";
    import ConfirmLeaveModal from "../../../components/Forms/ConfirmLeaveModal";
    import SingleSelect from "@/components/Select/SingleSelect";
    import ListSelect from "@/components/Select/ListSelect";
    import DataTable from "@/components/Table/DataTable";
    import { ACTIVITIES } from "@/store/auth/auth";
    import Stub from "@/components/Stub.vue";
    import RequestStatusIndicator from "@/pages/AppPages/Requests/RequestStatusIndicator.vue";
    import MapBox from "@/components/Map/MapBox.vue";
    import {MapMixin} from "@/components/Map/mapMixin";
    import MapMunicipalityList from "@/components/Map/MapMunicipalityList.vue";
    import AnimalLink from "@/pages/AppPages/Animals/AnimalLink.vue";
    import AnimalDropdownItem from "@/pages/AppPages/Animals/AnimalDropdownItem.vue";

    export default {
        name: "RequestDetail",
        components: {
            AnimalDropdownItem,
            AnimalLink,
            MapMunicipalityList,
            MapBox,
            RequestStatusIndicator,
            Stub,
            DataTable,
            ListSelect,
            SingleSelect,
            AnimalAvatar,
            FormField,
            RaidsList,
            ObjectFormButtons,
            ConfirmLeaveModal
        },
        mixins: [ ObjectComponentMixin, MapMixin ],
        props: {
            requestId: null,
        },
        validations() {
            if (this.form.activity === ACTIVITIES.CATCHING) {
                return {form: this.objectClass.catchingValidations}
            }
            return this.objectClass ? {form: this.objectClass.validations} : {}
        },
        data() {
            return {
                statusKey: null,
                animals: [],
                initialActivity: null,
            }
        },
        computed: {
            ...mapGetters(['ability', 'isMunicipalController', 'isInContractor', 'isInController',
                'isSuperuser', 'userLastValidContract', 'userLastValidContractObject', 'userValidContractObjectIds', 'userOrganizationMunicipalityNames',
                'userOrganizationId', 'userOrganizationActivities', 'userOrganizationMunicipalities', 'hasMunicipalityRestrictions']),
            getStatusUrl() {
                let url = api.requests.default.detail(this.$route.params.id);
                return api.requests.status.list(url);
            },
            getContractsUrl() {
                return api.contracts.default.list();
            },
            getAnimalsUrl() {
                return api.animals.default.list();
            },
            getActivitiesUrl() {
                return api.requests.activities.list();
            },
            getAnimalSpeciesUrl() {
                return api.species.default.list();
            },

            activitiesInitialFilters() {
                if (this.isInContractor && this.userLastValidContract) {
                    let filters = [];
                    for (const i of Object.keys(ACTIVITIES)) {
                        if (this.userOrganizationActivities.includes(ACTIVITIES[i]) ) {
                            filters.push({key: 'activity', value: ACTIVITIES[i]})
                        }
                    }
                    filters.push({key: 'activity'})
                    return filters
                }
                return []
            },
            requestStatuses() {
                return RequestStatus
            },
            contractInitialFilters() {
                const isReleaseShelter = this.isInContractor
                    && this.isRelease()
                    && this.userOrganizationActivities.indexOf(ACTIVITIES.RELEASE) >= 0;
                let filters = [{key: 'activity', value: this.form.activity}];

                // PETS-306: заявки на выпуск могут быть созданы по истекшим контрактам.
                // Если содержание давнее и его контракт истек, то у приюта должна быть возможность выбрать истекший контракт содержания
                if (!this.isRelease() && !this.isSuperuser) {
                    filters.push({key: 'is_valid', value: true})
                }

                if (this.selectedMunicipality) { filters.push({key: 'municipality', value: this.selectedMunicipality['id']}) }
                if (isReleaseShelter && !this.isSuperuser) {
                    filters.push({key: 'contractor', value: this.userOrganizationId})  // это дублируется в начальном queryset для контрактов, но пусть будет на всякий
                }
                return filters
            },
            animalsToReleaseInitialFilters() {
                // PETS-256: фильтровать не по контракту, как ранее, а по организации, которая относится к this.form.contract
                let data = [
                    {key: 'keeping_place', value: this.userOrganizationId},
                    {key: 'is_for_life', value: false},
                    {key: 'is_free', value: false},
                    {key: 'short', value: true}
                ]
                if (this.selectedMunicipality) { data.push({key: 'keeping_municipality', value: this.selectedMunicipality['id']}) }
                for (const a of this.object.animalObjectsToRelease) {
                    if (!a['can_release']) {
                        data.push({key: 'exclude', value: a['id']})
                    }
                }
                data.push({'key': 'page_size', 'value': 10}); // PETS-252: чтобы при большом количестве животных список не уезжал за границы экрана
                return data
            },
            canWork() {
                // PETS-280: разрешаем работать, если контракт из заявки в списке доступных у пользователя,
                // теперь нет необходимости выбирать его вручную
                // PETS-346: НО, чтобы приют мог взять в работу заявку на выпуск, созданную по истекшему контракту, для заявок на выпуск игнорируем это условие.
                return this.isSuperuser || (this.object.id && this.isInContractor
                    && (this.userValidContractObjectIds.indexOf(this.object.contract) >= 0 || this.isRelease())
                    && this.ability.can('update', this.object))
            },
            canMarkAsDone() {
                // PETS-393: Исполнитель должен иметь возможность сменить статус заявки
                // с "в работе" на "Выполнена" не зависимо от срока действия контракта.
                return this.isSuperuser || (this.object.id && this.isInContractor
                    && this.ability.can('update', this.object))
            },
            canControl() {
                return this.object.id
                    && (this.isInController
                        || (this.isMunicipalController
                            && this.object.authorOrganizationId === this.userOrganizationId
                            && this.ability.can('update', this.object)
                        )
                    )
                    || this.isSuperuser
            },
            canAddEvents() {
                const isCompletable = this.object.activity === ACTIVITIES.CATCHING;
                const isCompleted = isCompletable && this.object.animalsCount <= this.object.caughtCount
                return this.isSuperuser || this.object.id && this.object.status === RequestStatus.WIP
                    && (this.object.contract
                    && this.isInContractor && this.userValidContractObjectIds.indexOf(this.object.contract) >= 0
                    && this.ability.can('create', 'CatchingEvent')
                    && this.ability.can('create', 'Animal')
                    && (!isCompletable || isCompletable && !isCompleted)) ;
            },
        },
        methods: {
            // getAnimalLowercaseGender(animal) {
            //     return animal['gender_name'] ? animal['gender_name'].toLowerCase() : 'пол не указан'
            // },
            isCatching() {
                return parseInt(this.form.activity) === ACTIVITIES.CATCHING
            },
            isRelease() {
                return parseInt(this.form.activity) === ACTIVITIES.RELEASE
            },
            isMonitoring() {
                return parseInt(this.form.activity) === ACTIVITIES.MONITORING
            },
            canUpdateContract() {
                const forMunicipalController = this.isMunicipalController
                    && this.object.status !== RequestStatus.WIP
                    && this.object.status !== RequestStatus.DONE
                    && this.object.status !== RequestStatus.CLOSED
                    && this.object.status !== RequestStatus.CANCELLED;
                // PETS-306 - исполнитель, осуществляющий выпуск, должен иметь возможность выбрать один из своих контрактов
                const forReleaseShelter = this.isInContractor
                    && this.isRelease()
                    && this.userOrganizationActivities.indexOf(ACTIVITIES.RELEASE) >= 0;
                const forMonitoringShelter = this.isInContractor
                    && this.isMonitoring()
                    && this.userOrganizationActivities.indexOf(ACTIVITIES.MONITORING) >= 0;
                return (this.isSuperuser || forMunicipalController || forReleaseShelter || forMonitoringShelter);

            },
            canEditRequest() {
                return this.object.status !== RequestStatus.DONE
                    && this.object.status !== RequestStatus.CLOSED
                    && this.object.status !== RequestStatus.CANCELLED
            },
            getAnimalRoute(animal) {
                return {name: 'animalDetail', params: { id: animal.id }}
            },
            updateRequestObject() {
                const vm = this;
                this.updateObject().then(() => {
                    vm.setMapCoordinates(vm.object.coordinates)
                }).catch(() => {
                    vm.setMapCoordinates(vm.form.coordinates)
                });
            },
            updateStatus(newStatus, extraData = {}) {
                this.$v.form.status.$model = newStatus;
                if (extraData && Object.keys(extraData)) {
                    for (const key of Object.keys(extraData)) {
                        this.$v.form[key].$model = extraData[key];
                    }
                }
                this.updateRequestObject();
            },
            onCatchingEventCreate() {
                this.$router.push({ name: 'requestCatchingCreate', params: { initialRaid: null } })
            },
            onMonitoringEventCreate() {
                this.$router.push({ name: 'requestMonitoringCreate', params: { initialRaid: null } })
            },
            fetchRequestAnimals() {
                const vm = this;
                const params = { 'request': this.object.id };
                const animalsUrl = api.animals.default.list();
                httpClient.get(animalsUrl, {params : params}).then((response) => {
                    for (const i in response.data.results) {
                        const data = response.data.results[i];
                        vm.animals.push(data);
                    }
                })
            },
            onActivityChanged(name, item) {
                this.onModelObjectSingleSelectChanged(name, item)
                if (item.id === ACTIVITIES.CATCHING) {
                    this.object['animalsCount'] = 1;
                    this.form['animalsCount'] = 1;
                }
            },

            updateReleaseAnimalsField() {
                const vm = this;
                vm.objectData = null;
                vm.resetForm().then(() => {
                    if (vm.object.addressObject['id']) {
                        vm.setMapCoordinates(vm.object.coordinates)
                    }
                });
            },

            onMunicipalityClick(item) {
                const aboutToChange = this.toggleSelectedMunicipality(item);
                if (aboutToChange) {
                    this.form['contract'] = null;
                    this.form['contractObject'] = {};
                    this.$v.form.contract.$touch();
                    this.form['address'] = null;
                    this.form['addressObject'] = {};
                    this.$v.form.address.$touch();
                    this.selectedCoordinates = {};
                    this.nearestAddressData = {};
                }
            },

            cancelRequestChanges() {
                this.cancelChanges()
                this.setMapCoordinates(this.object.coordinates)
            }

        },
        mounted() {
            const vm = this;
            this.onMount();
            this.resetForm().then(() => {
                if (vm.object.addressObject['id']) {
                    vm.setMapCoordinates(vm.object.coordinates)
                }
            });
        },
        beforeMount() {
            const vm = this;
            vm.objectClass = Request;
            vm.objectId = vm.requestId ? vm.requestId : vm.$route.params.id;
            vm.apiEntryPoint = api.requests;
            vm.backRoute = 'requestsList';
            vm.nextRoute = 'requestsDetail';

            if (!vm.objectId && vm.userOrganizationMunicipalityNames && vm.userOrganizationMunicipalityNames.length > 0) {
                vm.selectedMunicipality = vm.userOrganizationMunicipalityNames[0]
            }

            vm.initObjectParams = {};

            const initialActivity = vm.$route.query['activity'];
            if (initialActivity) {
                vm.initObjectParams.activity = initialActivity;
                vm.initialActivity = initialActivity
            }

            // Для заявок на выпуск, чтобы автоматически назначать того же исполнителя, который провел отлов, PETS-233
            const releaseAnimalId = vm.$route.query['animal'];
            let animalPromise = new Promise((resolve, reject) => { resolve() });
            if (releaseAnimalId) {
                animalPromise = httpClient.get(api.animals.default.detail(releaseAnimalId));
            }
            animalPromise
                .then((response) => {
                    const releaseAnimalData = response['data'];
                    if (releaseAnimalData) {
                        vm.initObjectParams['animalsToRelease'] = [releaseAnimalData['id']];
                        vm.initObjectParams['animalObjectsToRelease'] = [releaseAnimalData];
                        vm.initObjectParams['animalsAvailableToRelease'] = [releaseAnimalData['id']];
                        const lastKeepingData = releaseAnimalData['last_keeping_object'];
                        const lastKeepingContractId = lastKeepingData['executor_contract_object']['id'];
                        const lastKeepingContractObject = lastKeepingData['executor_contract_object'];
                        vm.initObjectParams['contract'] = lastKeepingContractId;
                        vm.initObjectParams['contractObject'] = lastKeepingContractObject;
                        const keepingSourceAddressId = lastKeepingData['event_address_object']['id'];
                        if (keepingSourceAddressId) {
                            return httpClient.get(api.addresses.default.detail(keepingSourceAddressId))
                        }
                        return new Promise((resolve, reject) => { resolve() })
                    }
                })
                .then((response) => {
                    if (response) {
                        const addressData = response.data;
                        vm.initObjectParams['address'] = addressData['id'];
                        vm.initObjectParams['addressObject'] = addressData;
                        vm.initObjectParams['lat'] = addressData['lat'];
                        vm.initObjectParams['lon'] = addressData['lon'];
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    vm.resetForm().then(() => {
                        if (vm.object.addressObject['id']) {
                            vm.setMapCoordinates(vm.object.coordinates)
                            vm.selectedMunicipality = vm.object.municipalityObject
                        }
                        if (vm.object.id) {
                            vm.fetchRequestAnimals();
                        }
                    })
                })
        }
    }
</script>

<style scoped lang="scss">

</style>